import gql from 'graphql-tag';

export const createDeviceMutation = gql`
  mutation ($input: DeviceCreateInput) {
    createDevice(input: $input)
    {
      deviceId
      application {
        applicationId
      }
      name
      model {
        modelId
        name
        remark
      }
      serial
      mac
      region
      longitude
      latitude
      distance
      remark
      optional
      date
      active
    }
  }
`
